import { Spinner } from "@snapchat/snap-design-system";
import { Flexbox, FlexContainer } from "../Flexbox";
import { canvasMargin, loadingPlaceHolder } from "./CanvasLoading.styles";

export const CanvasLoading = () => {
    return (
        <Flexbox flexDirection="column" alignItems="baseline" flex="1" css={canvasMargin}>
            <FlexContainer alignItems="center" justifyContent="center" css={loadingPlaceHolder}>
                <Spinner size="x-large" color="gray" />
            </FlexContainer>
        </Flexbox>
    );
};
